import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function isDocumentNameExistsIncurrentEngagementReducer(
	state = initialState.isDocumentNameExistsIncurrentEngagement,
	action
) {
	switch (action.type) {
		case types.ASSOCIATE_TASK_DOCUMENTS: {
			if (
				action.response &&
				action.response.isDocumentNameAlreadyExists === true
			) {
				return true;
			}
			return false;
		}
		case types.CLEAR_ISDOCUMENTNAME_ALREADY_PRESENT_VALIDATION: {
			return false;
		}
		default:
			return false;
	}
}
